import {
  Icon,
} from 'semantic-ui-react';

import styled from 'styled-components';

const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${ r }, ${ g }, ${ b }, ${ alpha })`;
  }
  return `rgb(${ r }, ${ g }, ${ b })`;
};

const SocialIcon = styled(Icon).attrs(({ name = 'linkedin' }) => ({
  name,
  size: 'large',
}))`
  margin: 20px !important;
`;

const SocialButtonContainer = styled.div.attrs(({ provider }) => ({
  'data-oauth-command': `${provider}.call`,
}))`
  width: 300px;
  height: 40px;
  display: flex;
  flex-direction: row;
  background: ${({ bg }) => hexToRGB(bg, 0.8) || '#2a7bb6'};
  border: ${({ border }) => (border ? `${hexToRGB(border, 1)} 1px solid` : 'unset')};
  font-weight: 500;
  margin: 0px;
  padding: 1px;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;
  justify-content: center;

  &:hover {
    background: ${({ bg }) => hexToRGB(bg) || '#2a7bb6'};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25)
  }
`;

const SocialButtonIcon = styled.div`
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  height: auto;
  width: 38px;
  justify-content: center;
`;

const SociaButtonTitle = styled.span`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => (color ? `${hexToRGB(color, 1)}` : '#FFFFFF')};
`;

export {
  SocialButtonContainer,
  SocialButtonIcon,
  SocialIcon,
  SociaButtonTitle,
  hexToRGB,
};
